import type { AuthUser } from '@/types/auth';
import type { WeekDay } from './status-week';
import type { WeekStatesOpts } from './status-week';

export const STRIKES_HELP =
  'Cada día que no añadas el mínimo de creadores recibes una falta. Acumular 3 faltas activa el pre-ban.';

export const DAY_LABELS = ['L', 'M', 'X', 'J', 'V', 'S', 'D'] as const;

export const DAY_CLS: Record<WeekDay['state'], string> = {
  done: 'bg-success/20 text-success',
  fail: 'bg-error/15 text-error',
  pending: 'bg-white/[0.04] text-text-tertiary/60',
  ghost: 'bg-white/[0.02] opacity-30',
  vacation: 'bg-info/10 text-info/70',
  omitted: 'bg-white/[0.06] text-text-tertiary/50',
};

export function statusWeekOpts(user: AuthUser | null): WeekStatesOpts {
  return {
    joinedIso: user?.created?.slice(0, 10),
    streakResumedIso: user?.streak_resumed_at?.slice(0, 10),
    vacationFrom: user?.vacation_starts_at?.slice(0, 10),
    vacationTo: user?.vacation_ends_at?.slice(0, 10),
  };
}

export type StrikesTone = { label: string; cls: string };

export function pickTone(input: {
  status: string;
  faults: number;
}): StrikesTone {
  if (input.status === 'banned')
    return { label: 'Baneado', cls: 'text-error' };
  if (input.status === 'pre_banned')
    return { label: 'Pre-ban', cls: 'text-error' };
  if (input.faults >= 1)
    return { label: `${input.faults} faltas`, cls: 'text-error' };
  return { label: 'Al día', cls: 'text-success' };
}

export function dayContent(state: WeekDay['state'], label: string): string {
  if (state === 'ghost') return '';
  if (state === 'fail') return 'X';
  if (state === 'omitted') return '−';
  return label;
}
